<app-draggable-modal-wrapper>
    <h2
        mat-dialog-title
        modal-drag-handle
        class="!text-2xl !font-normal !text-primary-700 !mb-2"
    >
        FCC Licensing Contact Information Modified
    </h2>
    <mat-dialog-content class="mat-typography">
        You have entered or modified the application Contact info EWA stores for
        your convenience. Would you like to update this info for future use?
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="!p-5">
        <button
            id="decline-to-save-fcc-licensing-information"
            class="!border-primary-700"
            color="primary"
            type="button"
            color="primary"
            mat-stroked-button
            mat-dialog-close
            cdkFocusInitial
            (click)="declineToSaveInformation()"
        >
            No, Don't Change
        </button>
        <button
            id="agree-to-save-fcc-licensing-information"
            color="primary"
            type="button"
            mat-button
            mat-raised-button
            mat-dialog-close
            cdkFocusInitial
            (click)="agreeToSaveInformation()"
        >
            Yes, Update
        </button>
    </mat-dialog-actions>
</app-draggable-modal-wrapper>
